const subscribers = new Map();
/**
 * Provides event bus functions
 */
class FlashClass {
    constructor() {
        if (FlashClass.instance)
            return FlashClass.instance;
        FlashClass.instance = this;
        return this;
    }
    publish(key, data = false, no_publish = false) {
        //  IF no subscribers are found ... do nothing
        if (!subscribers.has(key))
            return;
        const subs = subscribers.get(key) || [];
        subs.forEach(subscriber => {
            if (subscriber.uid === no_publish)
                return;
            subscriber.fnHook(data);
        });
    }
    subscribe(uid, key, fnHook) {
        //  Create an empty subscribers array if no subscribers are registered
        //  for a specific data key
        if (!subscribers.has(key)) {
            subscribers.set(key, []);
        }
        subscribers.get(key).push({ uid, fnHook });
    }
    subscribeOnce(uid, key, fnHook) {
        this.subscribe(uid, key, data => {
            fnHook(data);
            this.unsubscribe(uid, key);
        });
    }
    unsubscribe(uid, key = false) {
        const to_unsubscribe = [];
        if (key === false) {
            // Unsubscribe from all keys
            subscribers.forEach((_, subscription_key) => {
                to_unsubscribe.push(subscription_key);
            });
        }
        else {
            // Unsubscribe from a specific key
            to_unsubscribe.push(key);
        }
        to_unsubscribe.forEach(subscription_key => {
            //  Filter out all subscriptions for this uid
            const pruned = (subscribers.get(subscription_key) || []).filter(subscriber => subscriber.uid !== uid);
            //  Patch or Remove subscribers for this subscription_key
            if (pruned.length === 0) {
                subscribers.delete(subscription_key);
            }
            else {
                subscribers.set(subscription_key, pruned);
            }
        });
    }
    //  Validate whether or not a specific key is being listened to
    hasSubscribers(key) {
        return (subscribers.get(key) || []).length > 0;
    }
    purge() {
        subscribers.clear();
    }
}
FlashClass.instance = null;
const Flash = new FlashClass();
export { Flash };
export default Flash;
//# sourceMappingURL=Flash.js.map